import * as React from 'react';

import styles from './SectionHeaderGhost.module.scss';

export const SectionHeaderGhost: React.FC = () => {
  return <div className={styles.wrapper} />;
};

export default SectionHeaderGhost;
